import React from 'react';

function Intro() {
  return (
    <>
        <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_DbCYKfCXBZ.json"  background="transparent"  speed="1"  id='code'  loop autoplay></lottie-player>
        <div className='socail_links'>
            <ul>
                <li> <a href='/'> <img src="https://img.icons8.com/ios/35/null/twitter--v1.png" alt='logo'/> </a></li>
                <li> <a href='https://www.linkedin.com/in/suryawanshi-sanket/'> <img src="https://img.icons8.com/windows/35/null/linkedin.png" alt='logo'/> </a></li>
                <li> <a href='https://github.com/SanketSuryawanshi'> <img src="https://img.icons8.com/ios-glyphs/35/null/github.png" alt='logo'/> </a></li>
                <li> <a href='https://www.instagram.com/_technicalsanket_/'> <img src="https://img.icons8.com/ios/35/null/facebook-new.png" alt='logo'/> </a></li>
                <li> <div className='line'></div> </li>
                <li> <span>Follow Me</span> </li>
            </ul>
        </div>
        <div className='intro container'>
            <div className='profile_pic'>
                <img src='https://i.ibb.co/824SZyJ/7-A50-E6-A2-E631-11-EC-9331-1624456-CC003.jpg' alt='profile' />
            </div>
            <h1>
                I'm <span>Sanket Sharad Suryawanshi</span> 
            </h1>
            <p>Full Stack Web Developer & Data Science Enthusiast</p>
            <div className='links'>
                <button className='btn'>Resume Dowload ⚡</button>
                <button className='btn'>Contact Me 📞</button>
            </div>                
        </div>
        <lottie-player src="https://assets7.lottiefiles.com/packages/lf20_w51pcehl.json"  background="transparent" id='laptop'  speed="1"  loop  autoplay></lottie-player>
    </>
  )
}

export default Intro